<template>
  <el-dialog :title="formData.title" :visible.sync="formData.delDiglogStatus" width="560px" :append-to-body="true">
    <h1 class="delDigClass">
      <!-- <i class="el-icon-warning"></i> -->
      <span>{{ formData.text1 }}</span>
      <label v-if="formData.text2">{{ formData.text2 }}</label>
    </h1>

    <span slot="footer" class="dialog-footer">
      <el-button @click="formData.delDiglogStatus = false">取 消</el-button>
      <el-button type="primary" @click="delEvent">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getDeleteClass, deleteOrder, deleteQuickOrder, deleteCustomerInfo
} from './api/index';

export default {
  data() {
    return {
      formData: {
        delDiglogStatus: false,
        title: '',
        id: '',
        url: '',
        text1: '',
        text2: '',
        status: false
      }
    };
  },
  created() {
    const vm = this;
    vm.$emit('delData', vm.formData);
  },
  methods: {
    delEvent() {
      const vm = this;
      if (vm.formData.url == 'getDeleteClass') {
        const data = { classId: vm.formData.id };
        getDeleteClass(data).then((res) => {
          if (res.code == 0) {
            vm.$message({ message: '删除成功', type: 'success' });
            vm.formData.delDiglogStatus = false;
            vm.formData.status = true;
          } else {
            vm.$message({ message: (res.message || '删除失败'), type: 'error' });
          }
        });
      } else if (vm.formData.url == 'deleteOrder') {
        const dataTwo = { id: vm.formData.id };
        deleteOrder(dataTwo).then((res) => {
          if (res.code == 0) {
            vm.$message({ message: '删除成功', type: 'success' });
            vm.formData.delDiglogStatus = false;
            vm.formData.status = true;
          } else {
            vm.$message('删除失败');
          }
        });
      } else if (vm.formData.url == 'deleteQuickOrder') {
        const dataThree = { orderId: vm.formData.id };
        deleteQuickOrder(dataThree).then((res) => {
          if (res.code == 0) {
            vm.$message({ message: '删除成功', type: 'success' });
            vm.formData.delDiglogStatus = false;
            vm.formData.status = true;
          } else {
            vm.$message('删除失败');
          }
        });
      } else if (vm.formData.url == 'deleteCustomer') {
        const dataFour = { busId: sessionStorage.getItem('busId'), phone: vm.formData.id };
        deleteCustomerInfo(dataFour).then((res) => {
          if (res.code == 0) {
            vm.$message({ message: '删除顾客成功', type: 'success' });
            vm.formData.delDiglogStatus = false;
            vm.formData.status = true;
          } else {
            vm.$message('删除失败');
          }
        });
      }
    }
  }
};
</script>

<style>
.delDigClass {
    height: auto;
    padding-bottom: 0;
}
.delDigClass i {
    font-size: 35px;
    color: #f7ba2a;
    float: left;
    padding-right: 10px;
}
.delDigClass span {
    display: block;
    height: 17px;
    line-height: 15px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
}
.delDigClass label {
    display: block;
    padding-top: 5px;
    height: 18px;
    line-height: 18px;
    font-size: 14px;
    color: #666;
    font-weight: 500;
}
</style>
